export enum TRIGGERS {
  ON_CLICK = 'OnClick',
}

export enum CATEGORIES {
  DISMISS = 'Dismiss',
  FLOW = 'Flow',
  FORM = 'Form',
  NATIVE = 'Native',
  PENDO = 'Pendo',
  TOUR = 'Tour',
  RICHTEXT = 'RichText',
}

/**
 * Interactions is an enum that represents the avaliable interactions
 * for a given component
 */
export enum INTERACTION_TYPES {
  None = 'None',
  URL = 'URL',
  Email = 'Email',
  Callback = 'Callback',
  Content = 'Content',
  TriggerModal = 'TriggerModal',
  TriggerTour = 'TriggerTour',
  TriggerHotspotGroup = 'TriggerHotspotGroup',
  DismissModal = 'DismissModal',
  Tour = 'Tour',
  DismissTour = 'DismissTour',
  Guide = 'Guide',
  Flow = 'Flow',
  Form = 'Form',
  Dismiss = 'Dismiss',
  DismissAndOpenNextHotspot = 'DismissAndOpenNextHotspot',
  DismissHotspot = 'DismissHotspot',
  DismissHotspotGroup = 'DismissHotspotGroup',
  FormSubmit = 'FormSubmit',
  CopyRichText = 'CopyRichText',
  TriggerClick = 'TriggerClick',
}

export enum HANDLER_TYPES {
  DISMISS = 'Dismiss',
  // flow
  FLOW_NEXT_STEP = 'NextStep',
  FLOW_SET_STEP = 'SetStep',
  FLOW_PREVIOUS_STEP = 'PreviousStep',

  // form - Deprecated
  LEGACY_SUBMIT_FORM = 'SubmitForm',
  LEGACY_SUBMIT_FORM_AND_SET_STEP = 'SubmitFormAndSetFlowStep',

  // form - correct
  FORM_SUBMIT = 'FormSubmit',

  // Tours
  DISMISS_TOUR = 'DismissTour',
  NEXT_TOUR_STEP = 'NextTourStep',
  PREVIOUS_TOUR_STEP = 'PreviousTourStep',

  // hotspots
  DISMISS_AND_OPEN_NEXT_HOTSPOT = 'DismissAndOpenNextHotspot',
  DISMISS_HOTSPOT = 'DismissHotspot',
  DISMISS_HOTSPOT_GROUP = 'DismissHotspotGroup',

  // rich text
  COPY_TEXT = 'CopyText',

  // native
  CALLBACK = 'Callback',
  DISMISSED_CARD = 'DismissedCard',
  CHANGE_CONTENT = 'ChangeContent',
  TRIGGER_MODAL = 'TriggerModal',
  TRIGGER_TOUR = 'TriggerTour',
  TRIGGER_HOTSPOT_GROUP = 'TriggerHotspotGroup',
  DISMISS_MODAL = 'DismissModal',
  NAVIGATE = 'Navigate',
  // pendo
  OPEN_GUIDE = 'OpenGuide',

  TRIGGER_CLICK = 'TriggerClick',
}

export interface DismissAction {
  category: CATEGORIES.DISMISS;
  handler: {
    type: HANDLER_TYPES.DISMISS;
  };
  eventName: string;
}

export interface CopyTextAction {
  category: CATEGORIES.RICHTEXT;
  handler: {
    type: HANDLER_TYPES.COPY_TEXT;
  };
  eventName: string;
}

/**
 * Flow
 */
export interface FlowPreviousStep {
  category: CATEGORIES.FLOW;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.FLOW_PREVIOUS_STEP;
  };
  eventName: string;
}

export interface FlowNextStep {
  category: CATEGORIES.FLOW;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.FLOW_NEXT_STEP;
  };
  eventName: string;
}

export interface FlowSetStep {
  category: CATEGORIES.FLOW;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.FLOW_SET_STEP;
    stepId: string;
  };
  eventName: string;
}

/**
 * Form
 */
export interface SubmitForm {
  category: CATEGORIES.FORM;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.LEGACY_SUBMIT_FORM;
  };
  eventName: string;
}

export interface SubmitFormAndFlowSetStep {
  category: CATEGORIES.FORM;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.LEGACY_SUBMIT_FORM_AND_SET_STEP;
  };
  eventName: string;
}

export interface FormSubmit {
  category: CATEGORIES.FORM;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.FORM_SUBMIT;
  };
  eventName: string;
}

/**
 * Native
 */
export interface CallbackAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.CALLBACK;
    name: string;
  };
  eventName: string;
}

export interface NavigateAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.NAVIGATE;
    href: string;
    target?: 'Blank' | 'Self' | 'Top' | 'Parent';
  };
  eventName: string;
}

export interface ChangeContentAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.CHANGE_CONTENT;
    slug: string;
  };
  eventName: string;
}

/** Tour */
export interface DismissTour {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.DISMISS_TOUR;
  };
  eventName: string;
}

export interface NextTourStep {
  category: CATEGORIES.TOUR;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.NEXT_TOUR_STEP;
  };
  eventName: string;
}

export interface PreviousTourStep {
  category: CATEGORIES.TOUR;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.PREVIOUS_TOUR_STEP;
  };
  eventName: string;
}

export interface DismissHotspot {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.DISMISS_HOTSPOT;
  };
  eventName: string;
}

export interface DismissAndOpenNextHotspot {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.DISMISS_AND_OPEN_NEXT_HOTSPOT;
  };
  eventName: string;
}

export interface DismissHotspotGroup {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.DISMISS_HOTSPOT_GROUP;
  };
  eventName: string;
}

/**
 * Modal
 */
export interface TriggerModalAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.TRIGGER_MODAL;
    slug: string;
  };
  eventName: string;
}

export interface TriggerTourAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.TRIGGER_TOUR;
    slug: string;
  };
  eventName: string;
}

export interface TriggerHotspotGroupAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.TRIGGER_HOTSPOT_GROUP;
    slug: string;
  };
  eventName: string;
}

export interface DismissModalAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.DISMISS_MODAL;
    void: string;
  };
  eventName: string;
}

export interface DismissedCardAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.DISMISSED_CARD;
    cardId: string;
  };
  tutorialId: string;
  eventName: string;
}

/**
 * Pendo
 */
export interface PendoOpenGuideAction {
  category: CATEGORIES.PENDO;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.OPEN_GUIDE;
    guideId: string;
  };
  eventName: string;
}

export interface TriggerClickAction {
  category: CATEGORIES.NATIVE;
  trigger: TRIGGERS.ON_CLICK;
  handler: {
    type: HANDLER_TYPES.TRIGGER_CLICK;
    selector: string;
  };
  eventName: string;
}

export type Action =
  | DismissAction
  // flows
  | FlowNextStep
  | FlowPreviousStep
  | FlowSetStep

  // forms - Deprecated
  | SubmitForm
  | SubmitFormAndFlowSetStep

  // Dismiss
  | DismissAndOpenNextHotspot
  | DismissHotspot
  | DismissHotspotGroup

  // Tour
  | DismissTour
  | NextTourStep
  | PreviousTourStep

  // Forms
  | FormSubmit

  // Richtext
  | CopyTextAction

  // native
  | ChangeContentAction
  | TriggerModalAction
  | TriggerTourAction
  | TriggerHotspotGroupAction
  | DismissModalAction
  | CallbackAction
  | DismissedCardAction
  | NavigateAction

  // pendo
  | PendoOpenGuideAction;
